import template from './certificates-filter.html';
import CertificatesFilterController from './certificates-filter.controller';
import './certificates-filter.styl';

let certificatesFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template,
  controller: CertificatesFilterController,
  controllerAs: 'vm'
};

export default certificatesFilterComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/certificates-filter/certificates-filter.component.js
 **/